import { render, staticRenderFns } from "./ReactionCountFull.vue?vue&type=template&id=903499f6&scoped=true&lang=pug"
import script from "./ReactionCountFull.vue?vue&type=script&lang=ts"
export * from "./ReactionCountFull.vue?vue&type=script&lang=ts"
import style0 from "./ReactionCountFull.vue?vue&type=style&index=0&id=903499f6&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "903499f6",
  null
  
)

export default component.exports